(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kelmere-product"] && !Shopify.designMode) return;
  try {
    
  const setupKelmereGalleries = () => {
    document.querySelectorAll('[data-kl-gallery]').forEach((shell) => {
      if (shell.dataset.ready === 'true') return;
      shell.dataset.ready = 'true';

      const gallery = shell.querySelector('.kl-pdp__gallery');
      const slides = [...shell.querySelectorAll('[data-kl-slide]')];
      const thumbs = [...shell.querySelectorAll('[data-kl-thumb]')];
      const current = shell.querySelector('[data-kl-current]');
      const previous = shell.querySelector('[data-kl-prev]');
      const next = shell.querySelector('[data-kl-next]');
      if (!gallery || slides.length < 2) return;

      let active = 0;
      let frame;
      const update = (index) => {
        active = Math.max(0, Math.min(index, slides.length - 1));
        if (current) current.textContent = String(active + 1);
        thumbs.forEach((thumb, thumbIndex) => {
          if (thumbIndex === active) thumb.setAttribute('aria-current', 'true');
          else thumb.removeAttribute('aria-current');
        });
      };
      const go = (index) => {
        const target = (index + slides.length) % slides.length;
        gallery.scrollTo({ left: slides[target].offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
        update(target);
      };

      previous?.addEventListener('click', () => go(active - 1));
      next?.addEventListener('click', () => go(active + 1));
      thumbs.forEach((thumb) => thumb.addEventListener('click', () => go(Number(thumb.dataset.klThumb))));
      gallery.addEventListener('scroll', () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          const centre = gallery.scrollLeft + gallery.clientWidth / 2;
          let closest = 0;
          let distance = Infinity;
          slides.forEach((slide, index) => {
            const slideCentre = slide.offsetLeft + slide.clientWidth / 2;
            const nextDistance = Math.abs(centre - slideCentre);
            if (nextDistance < distance) {
              closest = index;
              distance = nextDistance;
            }
          });
          update(closest);
        });
      }, { passive: true });
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupKelmereGalleries, { once: true });
  else setupKelmereGalleries();
  document.addEventListener('shopify:section:load', setupKelmereGalleries);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
